import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Row, Col, Card } from 'react-bootstrap'
import configs from '../../config'
import Cookies from 'js-cookie'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Colors from '../../constants/Colors'
import { useDispatch } from 'react-redux'
import OrderList from './OrderList'
import OrderDetail from './OrderDetail'
import OrderDetailLoading from './OrderDetailLoading'
import OrderFilterStatus from './OrderFilterStatus'
import config from '../../config'
import OrderSearchBox from './OrderSearchBox'
import CreateOrderModal from './CreateOrderModal'
import Swal from 'sweetalert2'

const DATA_WEBSOCKET_ERROR = {
  dataNotChange: 'order action status not change.',
  invalidOrder: 'invalid order status.',
  orderWasLock: 'The given order id was locked.',
  permision: "You don't have permission to unlock this order.",
  rpc: 'rpc error: code = Internal desc = the provided hex string is not a valid ObjectID',
}

function Order() {
  const dispatch = useDispatch()
  const workingStatus = useRef('CONFIRMED')
  const action = useRef('NONE')
  const [orderNo, setOrderNo] = useState(null)
  const [userNo, setUserNo] = useState(null)
  const [firstName, setFirstName] = useState(null)
  const [lastName, setLastName] = useState(null)
  const [sort, setSort] = useState('ASC')
  const sortRef = useRef(sort)
  const [phoneNo, setPhoneNo] = useState(null)
  const admin = useSelector((state) => state.admin)
  const { roundDate } = useSelector((state) => state.webConfig)
  const orderSelected = useRef(null)
  const [orders, setOrders] = useState([])
  const [orderDetail, setOrderDetail] = useState(null)
  const [bgCardColor, setBgCardColor] = useState('bg-warning')
  const [messageStatus, setMessageStatus] = useState('แจ้งโอนแล้ว')
  const [fullPage, setFullPage] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowCreateOrderModal, setIsShowCreateOrderModal] = useState(false)
  const [orderIdSelected, setOrderIdSelected] = useState([])
  const [orderSelectedAfter, setOrderSelectedAfter] = useState(null)
  const [isDelivery, setIsDelivery] = useState(false)

  const ws = useRef()

  window.addEventListener('beforeunload', () => {
    orderSelected.current && handleUnlockOrder(orderSelected.current)
  })

  const addOrderInList = (message) => {
    const fullName = message?.data?.username.split(' ')
    const firstName = fullName[0]
    const lastName = fullName[1]
    const actionMessage = message?.action === 'NEW' ? 'NONE' : message.action
    const data = {
      action: {
        action: actionMessage,
      },
      createdAt: message.data.createdAt,
      id: message.id,
      orderNo: message.data.orderNo,
      status: 'CONFIRMED',
      user: {
        userNo: message.data.userNo,
        firstName: firstName,
        lastName: lastName,
      },
      totalPrice: message.data.price,
    }
    setOrders((lockedOrders) => {
      const newOrders = [...lockedOrders, data]
      newOrders.sort((a, b) => {
        if (sortRef.current === 'ASC') {
          return new Date(a.createdAt) - new Date(b.createdAt)
        } else {
          return new Date(b.createdAt) - new Date(a.createdAt)
        }
      })
      return [...newOrders]
    })
  }

  const removeOrderInList = (message) => {
    if (message.id === orderSelected.current?.id) {
      reset()
    }
    setOrders((orders) => {
      const ordersFilter = orders.filter((item) => item.id !== message.id)
      return [...ordersFilter]
    })
  }

  const addOrderInWatchList = (message) => {
    if (message.id === orderSelected.current?.id) return
    setOrderIdSelected((lockedOrders) => [...lockedOrders, message])
  }

  const removeOrderInWatchList = (message) => {
    setOrderIdSelected((orders) => {
      const ordersFilter = orders.filter((item) => item.id !== message.id)
      return [...ordersFilter]
    })
  }

  const reset = () => {
    setOrderDetail(null)
    setOrderSelectedAfter(null)
    setFullPage(false)
    orderSelected.current = null
  }

  const fetchOrders = async () => {
    const params = new URLSearchParams()

    switch (workingStatus.current) {
      case 'SEARCH':
        orderNo && params.append('orderNo', orderNo)
        userNo && params.append('userNo', userNo.toUpperCase())
        firstName && params.append('firstName', firstName)
        lastName && params.append('lastName', lastName)
        sort && params.append('sort', 'DESC')
        phoneNo && params.append('phoneNo', phoneNo)
        isDelivery && params.append('isDelivery', isDelivery)
        break
      default:
        sort && params.append('sort', sort)
        workingStatus.current && params.append('status', workingStatus.current)
        action.current && params.append('action', action.current)
        roundDate && params.append('roundDate', roundDate)
        isDelivery && params.append('isDelivery', isDelivery)
        break
    }

    try {
      dispatch({ type: 'loading_show' })
      const requestUrl = `${configs.apiAdminGateway}/api/v3/admin/orders?${params.toString()}`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      const response = await fetch(requestUrl, {
        method: 'GET',
        headers: myHeaders,
      })

      const { data: orders, status } = await response.json()

      if (status.code !== 0) throw new Error('Error fetching orders')

      const orderIdFilter = orders
        .filter((item) => item.action.action === 'IN_PROGRESS' && item.status === 'CONFIRMED')
        .map((item) => ({ id: item.id, action: item.action.action }))

      if (workingStatus.current === 'SEARCH') {
        workingStatus.current = 'SEARCH'
        setMessageStatus(`ผลการค้นหา จำนวน ${orders.length}`)
        setBgCardColor('bg-primary')
      }

      setOrderIdSelected(orderIdFilter)
      setOrders(orders)
      reset()
    } catch (err) {
      setOrders([])
      reset()
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchOrderDetail = async (order) => {
    try {
      setIsLoading(true)
      const requestUrl = `${config.apiAdminGateway}/api/v3/admin/orders/${order.id}`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      const response = await fetch(requestUrl, {
        method: 'GET',
        headers: myHeaders,
      }).then((res) => res.json())
      const { data: orderDetail } = response

      const paymentResponse = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/${orderDetail.paymentId}`, {
        method: 'GET',
        headers: myHeaders,
      }).then((res) => res.json())

      if ('status' in paymentResponse ? paymentResponse.status?.code !== 0 : paymentResponse?.code !== 0) {
        setOrderDetail({ ...orderDetail, paymentId: '', notes: [], remainingAmount: 0 })
      } else {
        const {
          data: { id: paymentId, note, remainingAmount },
        } = paymentResponse

        setOrderDetail({ ...orderDetail, paymentId, notes: note || [], remainingAmount: remainingAmount })
      }

      orderSelected.current = order
      setFullPage(true)

      if (
        (order.status === 'SUCCESS' ||
          (order.status === 'CONFIRMED' && order.action.action === 'BLOCKED') ||
          order.status === 'CANCEL') &&
        orderIdSelected &&
        orderSelectedAfter
      ) {
        handleUnlockOrder(orderSelectedAfter)
      }

      if (order.action.action === 'NONE' && order.status === 'CONFIRMED') {
        if (order?.id !== orderSelectedAfter?.id && orderSelectedAfter !== null) {
          await handleSwitchOrder(orderSelectedAfter, order)
        } else if (order?.id === orderSelectedAfter?.id) {
          return
        } else {
          await handleLockOrder(order)
        }
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }
  const connectWs = useCallback(() => {
    ws.current = new WebSocket(`wss://${configs.apiAdminWsGateway}/ws`)

    ws.current.onopen = () => {
      ws.current.send(JSON.stringify({ token: Cookies.get('accessToken'), topic: 'UPDATE-ORDER-ACTION' }))
      console.log('connect web socket')
    }

    ws.current.onmessage = (event) => {
      switch (event.data) {
        case DATA_WEBSOCKET_ERROR.dataNotChange:
        case DATA_WEBSOCKET_ERROR.invalidOrder:
          return
        case DATA_WEBSOCKET_ERROR.orderWasLock:
        case DATA_WEBSOCKET_ERROR.rpc:
          Swal.fire({
            icon: 'error',
            title: 'ออเดอร์นี้ถูกล็อคอยู่แล้ว',
            text: 'คุณไม่มีสิทธิ์ล็อคออเดอร์นี้',
            showCloseButton: true,
          })
          reset()
          return
        case DATA_WEBSOCKET_ERROR.permision:
          switch (workingStatus.current) {
            case 'PENDING':
            case 'SUCCESS':
            case 'CANCEL':
              return
            case 'CONFIRMED':
              if (action.current === 'NONE') {
                return
              } else if (action.current === 'IN_PROGRESS') {
                Swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถปลดล็อคออเดอร์ได้',
                  text: 'เนื่องจากออเดอร์นี้เป็นของแอดมินท่านอื่น',
                  showCloseButton: true,
                })
                return
              } else if (action.current === 'BLOCKED') {
                return
              }
              return
            default:
              break
          }
          return
        default:
          const message = JSON.parse(event.data)
          const messageType = message?.action
          switch (workingStatus.current) {
            case 'PENDING':
              return
            case 'CONFIRMED':
              if (orders?.length >= 50) return
              if (action.current === 'NONE') {
                if (messageType === 'NEW') {
                  addOrderInList(message)
                } else if (messageType === 'NONE') {
                  removeOrderInWatchList(message)
                } else if (messageType === 'IN_PROGRESS') {
                  addOrderInWatchList(message)
                } else if (messageType === 'SUCCESS' || messageType === 'BLOCKED') {
                  removeOrderInList(message)
                  removeOrderInWatchList(message)
                }
              } else if (action.current === 'IN_PROGRESS') {
                if (messageType === 'NONE') {
                  removeOrderInList(message)
                  removeOrderInWatchList(message)
                } else if (messageType === 'IN_PROGRESS') {
                  addOrderInWatchList(message)
                } else if (messageType === 'SUCCESS' || messageType === 'BLOCKED') {
                  removeOrderInList(message)
                  removeOrderInWatchList(message)
                }
              } else if (action.current === 'BLOCKED') {
                return
              }
              return
            case 'SUCCESS':
              return
            case 'CANCEL':
              return
            default:
              break
          }
          break
      }
    }

    ws.current.onclose = (e) => {
      setTimeout(function () {
        connectWs()
      }, 1000)
    }
  }, [])

  useEffect(() => {
    connectWs()
  }, [connectWs])

  const handleLockOrder = async (order) => {
    const body = JSON.stringify({
      token: Cookies.get('accessToken'),
      action: 'IN_PROGRESS',
      id: order.id,
      topic: 'UPDATE-ORDER-ACTION',
      payload: JSON.stringify({
        action: 'IN_PROGRESS',
        id: order.id,
      }),
    })

    if (ws.current.readyState === WebSocket.CLOSED) {
      connectWs()
      setTimeout(() => {
        ws.current.send(body)
        setOrderSelectedAfter(order)
      }, 1000)
      return
    }

    if (ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(body)
      setOrderSelectedAfter(order)
    }
  }

  const handleUnlockOrder = async (order) => {
    const body = JSON.stringify({
      token: Cookies.get('accessToken'),
      action: 'NONE',
      id: order?.id,
      topic: 'UPDATE-ORDER-ACTION',
      payload: JSON.stringify({
        action: 'NONE',
        id: order?.id,
      }),
    })

    if (ws.current.readyState === WebSocket.CLOSED) {
      connectWs()
      setTimeout(() => ws.current.send(body), 1000)
      return
    }

    if (ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(body)
      setOrderSelectedAfter(null)
    }
  }

  const handleBlockOrder = async (order) => {
    const body = JSON.stringify({
      token: Cookies.get('accessToken'),
      action: 'BLOCKED',
      id: order?.id,
      topic: 'UPDATE-ORDER-ACTION',
      payload: JSON.stringify({
        action: 'BLOCKED',
        id: order?.id,
      }),
    })

    if (ws.current.readyState === WebSocket.CLOSED) {
      connectWs()
      setTimeout(() => ws.current.send(body), 1000)
      return
    }

    if (ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(body)
      reset()
    }
  }

  const handleSwitchOrder = async (oldOrder, newOrder) => {
    const body = JSON.stringify({
      token: Cookies.get('accessToken'),
      action: 'NONE',
      id: oldOrder.id,
      topic: 'UPDATE-ORDER-ACTION',
      payload: JSON.stringify({
        action: 'NONE',
        id: oldOrder.id,
      }),
    })

    if (ws.current.readyState === WebSocket.CLOSED) {
      connectWs()
      setTimeout(() => ws.current.send(body), 1000)
      handleLockOrder(newOrder)
      return
    }

    if (ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(body)
      handleLockOrder(newOrder)
    }
  }

  const unlockOrder = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if (
        (orderSelected.current?.action.action === 'NONE' || orderSelected.current?.action.action === 'IN_PROGRESS') &&
        orderSelected.current?.status === 'CONFIRMED'
      ) {
        handleUnlockOrder(orderSelected.current)
      }
      reset()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleOnClickOrderStatus = (value) => {
    setMessageStatus(value.message)
    setBgCardColor(value.color)
    workingStatus.current = value.status
    action.current = value.action
  }

  const onClickSearch = async () => {
    await unlockOrder()
    await fetchOrders()
  }

  const handleOnSearch = (e) => {
    if (e.code === 'Enter') {
      if (workingStatus.current === 'SEARCH') {
        onClickSearch()
      }
      workingStatus.current = 'SEARCH'
    }
  }

  useEffect(() => {
    if (
      (orderSelected.current?.action.action === 'NONE' || orderSelected.current?.action.action === 'IN_PROGRESS') &&
      orderSelected.current?.status === 'CONFIRMED'
    ) {
      handleUnlockOrder(orderSelected.current)
    }
    fetchOrders()
  }, [workingStatus.current, action.current, admin, isDelivery])

  return (
    <Fragment>
      <CreateOrderModal isShow={isShowCreateOrderModal} onClickCancel={() => setIsShowCreateOrderModal(false)} />
      <TabMenu>
        <div className="d-flex pb-2">
          <div className="btn-group pr-4">
            <div
              role="button"
              tabIndex={0}
              className={!isDelivery ? 'btn btn-danger' : 'btn btn-outline-danger'}
              style={{
                borderRadius: '20px 0 0 20px',
                minWidth: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                borderColor: Colors.LIGHT_RED,
                color: !isDelivery ? Colors.WHITE : Colors.LIGHT_RED,
                backgroundColor: !isDelivery ? Colors.LIGHT_RED : 'transparent',
              }}
              onClick={() => setIsDelivery(false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setIsDelivery(false)
                }
              }}
            >
              ลอตเตอรี่
            </div>
            <div
              role="button"
              tabIndex={0}
              className={isDelivery ? 'btn btn-danger' : 'btn btn-outline-danger'}
              style={{
                borderRadius: '0 20px 20px 0',
                minWidth: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                borderColor: Colors.LIGHT_RED,
                color: isDelivery ? Colors.WHITE : Colors.LIGHT_RED,
                backgroundColor: isDelivery ? Colors.LIGHT_RED : 'transparent',
              }}
              onClick={() => setIsDelivery(true)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setIsDelivery(true)
                }
              }}
            >
              จัดส่ง
            </div>
          </div>
        </div>
        <BoxOrderFilterStatus>
          <OrderFilterStatus
            workingStatus={workingStatus.current}
            onClick={(value) => handleOnClickOrderStatus(value)}
            onClickCreate={() => setIsShowCreateOrderModal(true)}
            action={action.current}
          />
        </BoxOrderFilterStatus>
      </TabMenu>
      <Row>
        <Col>
          <OrderSearchBox
            onClickSearch={onClickSearch}
            handleOnSearch={handleOnSearch}
            workingStatus={workingStatus.current}
            setOrderNo={setOrderNo}
            orderNo={orderNo}
            setUserNo={setUserNo}
            userNo={userNo}
            setFirstName={setFirstName}
            firstName={firstName}
            setLastName={setLastName}
            lastName={lastName}
            setSort={setSort}
            sort={sort}
            sortRef={sortRef}
            setPhoneNo={setPhoneNo}
            phoneNo={phoneNo}
          />
        </Col>
      </Row>
      <Row className="mt-0 pt-0">
        <Col sm={fullPage ? 12 : 4} lg={fullPage ? 12 : 4} md={fullPage ? 12 : 4} xl={fullPage ? 12 : 4}>
          <Card className={fullPage ? bgCardColor : bgCardColor} style={{ height: '100vh' }}>
            <Row className="h-100">
              <Col>
                <div className="h-100">
                  <Card.Header>
                    <Card.Title
                      className={workingStatus.current === 'SEARCH' ? 'd-flex text-white' : ''}
                      style={{ width: '100%' }}
                    >
                      <div className="flex align-items-center justify-content-between flex-col">
                        {workingStatus.current === 'SEARCH' ? (
                          <div style={{ color: 'white' }}>{messageStatus}</div>
                        ) : (
                          <div
                            style={{
                              textAlign: 'center',
                              paddingBottom: '16px',
                            }}
                          >
                            {messageStatus}
                          </div>
                        )}
                      </div>
                    </Card.Title>
                    {fullPage && (
                      <span
                        onClick={() => {
                          unlockOrder()
                        }}
                        className="badge"
                        style={{
                          borderRadius: '5rem',
                          backgroundColor: '#000',
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        X
                      </span>
                    )}
                  </Card.Header>
                  <Card.Body className="h-100">
                    <Row className="h-100">
                      <Col md={fullPage ? 4 : 12} lg={fullPage ? 4 : 12}>
                        <OrderList
                          orders={orders}
                          orderDetail={orderDetail}
                          fetchOrderDetail={fetchOrderDetail}
                          orderIdSelected={orderIdSelected}
                          action={action.current}
                          workingStatus={workingStatus.current}
                          orderSelected={orderSelected.current}
                        />
                      </Col>
                      {fullPage && (
                        <Col md={8} lg={8}>
                          {isLoading ? (
                            <OrderDetailLoading />
                          ) : (
                            orderDetail && (
                              <OrderDetail
                                order={orderDetail}
                                fetchOrderDetail={fetchOrderDetail}
                                fetchOrders={fetchOrders}
                                workingStatus={workingStatus.current}
                                setFullpage={setFullPage}
                                setBgCardColor={setBgCardColor}
                                setMessageStatus={setMessageStatus}
                                setOrderDetail={setOrderDetail}
                                handleBlockOrder={handleBlockOrder}
                                setOrderIdSelected={setOrderIdSelected}
                                setOrderSelectedAfter={setOrderSelectedAfter}
                                unlockOrder={unlockOrder}
                              />
                            )
                          )}
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Fragment>
  )
}
export default Order

const TabMenu = styled.div`
  display: flex;
  height: 54px;
  align-items: flex-end;
  margin-bottom: 8px;
`
const BoxOrderFilterStatus = styled.div`
  flex: 4;
`
